








import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class SidePanel extends Vue {
  @Prop() zone!: any;
  @Prop() catalog!: any;
  @Prop() context!: any;

  open = false;

  @Watch('zone')
  zoneChange() {
    console.log('updateWidget on zone');
    this.updateWidget();
  }

  @Watch('catalog')
  catalogChange() {
    console.log('updateWidget on zone');
    this.updateWidget();
  }

  @Watch('context')
  contextChange() {
    console.log('updateWidget on zone');
    this.updateWidget();
  }

  mounted() {
    console.log('mounted updateWidget on zone');
    this.updateWidget();
  }

  updateWidget() {
    if (!this.context || !this.catalog || !this.zone) {
      return;
    }
    const zoneProductListWidget: any = this.$refs.zoneProductListWidget;
    zoneProductListWidget.context = this.context;
    zoneProductListWidget.catalog = this.catalog;
    zoneProductListWidget.zone = this.zone;

    this.openSidePanel();
  }

  openSidePanel() {
    (this.$refs.sidePanel as any).open();
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        this.open = true;
        this.$emit('openPanel');
      });
    });
  }

  closePanel(event: CustomEvent) {
    if (
      this.open &&
      event.target &&
      (event.target as any).tagName &&
      (event.target as any).tagName.toUpperCase() === 'CSM-PANEL'
    ) {
      window.console.log('on side panel close on zone');
      this.$emit('closePanel');
      this.open = false;
    }
  }
}
